import type { Component } from 'vue';

const load = () => import('./ui/index.vue');

export const AppSuccessModal: Component = defineAsyncComponent(() =>
  load().then((m: { default: Component }) => m.default),
);

export const prefetchAppSuccessModal = (): void => {
  load().catch(() => null);
};
